import React from 'react';
import { useRoomContext } from '@livekit/components-react';
import { prepareFixedInput } from '@/lib/fixedRtcInput';

export default function FixedInputDiagnostic({ enabled = false }) {
  const room = useRoomContext();
  const current = React.useRef(null), busy = React.useRef(false), alive = React.useRef(true);
  const abort = React.useRef(null);
  const [ready, setReady] = React.useState(false), [played, setPlayed] = React.useState(false);
  const [error, setError] = React.useState('');
  React.useEffect(() => { alive.current = true; return () => {
    alive.current = false; abort.current?.abort();
    if (current.current) Promise.resolve(current.current.close()).catch(() => {});
  }; }, []);
  if (!enabled) return null;
  async function prepare() {
    if (busy.current || current.current) return;
    busy.current = true;
    try {
      abort.current = new AbortController();
      const input = await prepareFixedInput(room, { signal: abort.current.signal });
      if (!alive.current) { await input.close(); return; }
      current.current = input; setReady(true);
    } catch (_) { if (alive.current) setError('Fixed input unavailable. No AI start was requested.'); }
    finally { busy.current = false; }
  }
  return <section aria-label="Fixed speech diagnostic">
    <p>Test-only fixed speech. No microphone or camera capture. This does not start AI.</p>
    <button onClick={prepare} disabled={ready}>Prepare fixed speech track</button>
    <button disabled={!ready || played} onClick={() => {
      try { current.current.play(); setPlayed(true); }
      catch (_) { setError('Fixed input is closed or already used.'); }
    }}>Play fixture once after AI reports listening</button>
    <button disabled={!ready} onClick={async () => {
      await current.current?.close(); setReady(false); setPlayed(true);
    }}>Stop fixed input</button>
    {error && <p role="alert">{error}</p>}
  </section>;
}
